import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalController, PickerController, AlertController } from '@ionic/angular';
import { forkJoin } from 'rxjs';

import { Capacitor } from '@capacitor/core';

import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

import { Contact } from '../models/contact';
import { Invoice } from '../models/invoice';
import { WorkItem } from '../models/work-item';
import { Business } from '../models/business';

import { ApiService } from '../services/api.service';
import { AuthService } from '../services/auth.service';
import { AiService } from '../services/ai.service';

import { Router } from '@angular/router';

import { ContactsSelectorComponent } from '../contacts-selector/contacts-selector.component';
import { BusinessSelectorComponent } from '../business-selector/business-selector.component';
import { WorkItemChooserComponent } from '../work-item-chooser/work-item-chooser.component';
import { WorkItemEditComponent } from '../work-item-edit/work-item-edit.component';
import { PropertyChooserComponent } from '../property-chooser/property-chooser.component';

import { Property } from '../models/property';

@Component({
  selector: 'app-invoice-new',
  templateUrl: './invoice-new.page.html',
  styleUrls: ['./invoice-new.page.scss'],
  providers: [  ]
})
export class InvoiceNewPage implements OnInit {

  chosenContact: Contact;
  isNativePlatform = true;
  ionicForm: UntypedFormGroup;
  isSubmitted = false;
  properties = [];
  WorkItems: WorkItem[];
  newInvoice: Invoice;
  chosenBusiness: Business;
  accountCurrency: string;
  loadingFromAI = false;
  @Input() public contactId: number;
  @Input() public jobId: number;

  constructor(
    public modalCtrl: ModalController, 
    public pickerCtrl: PickerController, 
    public alertController: AlertController,
    public formBuilder: UntypedFormBuilder, 
    public apiService: ApiService, 
    public router: Router,
    public authService: AuthService,
    public aiService: AiService) { }

  ngOnInit() {
    this.isNativePlatform = Capacitor.isNativePlatform();

    var todaysDate = new Date();

    // Build Invoice Form
    this.ionicForm = this.formBuilder.group({
      contactId: ['', [Validators.required]],
      businessId: ['', [Validators.required]],
      propertyId: [''],
      customer: {},
      business: {},
      property: {},
      currency: 'GBP',
      jobId: null,
      invoice_date: todaysDate.toISOString(),
    })

    this.newInvoice = new Invoice().deserialize({});

    // Setup WorkItems
    this.WorkItems = [];

    // Get selected Account currency
    this.authService.getSelectedAccount().then((account) => {
      this.accountCurrency = account.currency;

      // Patch New Invoice Form
      this.ionicForm.patchValue(
        {
          currency: account.currency
        }
      );

      // Currency for New Invoice Model
      this.newInvoice.currency = account.currency
    });

    // Load Job details if provided
    if (this.jobId) {

      this.newInvoice.jobId = this.jobId;

      this.apiService.getJob(this.jobId).subscribe(response => {
        // Handle the fetched job details
        const existingJob = response;

        console.log(existingJob);
        // Update form values
        this.ionicForm.patchValue(
          {
            jobId: existingJob.id
          });
      },
      error => {
        // Handle any errors
        console.log(error);
      });
      
    }

    if (this.contactId) {
      this.setupContactForm(this.contactId);
    }

    // Get businesses and if we have 1 business, then pre-populate the form
    this.apiService.getBusinessList().subscribe(response => {
      if (response.length === 1) {
        console.log(response[0]);
        this.ionicForm.patchValue(
          {
            businessId: response[0].id,
            business: {
              name: response[0].name,
              taxName: response[0].taxName,
            }
          }
        );

        // Update model
        this.newInvoice.businessId = response[0].id;

        // Chosen business
        this.chosenBusiness = response[0];
      }
    });

  }

  setupContactForm(contactId) {
    // Get contact
    this.apiService.getContact(contactId).subscribe(response => {

      // Pre-populate form values
      this.ionicForm.patchValue(
        {
          contactId: response.id,
          customer: {
            title: response.title,
            first_name: response.first_name,
            last_name: response.last_name,
            mainName: response.mainName,
            email: response.email,
            phone1: response.phone1,
            phone2: response.phone2,
            address1: response.address1,
            address2: response.address2,
            city: response.city,
            postcode: response.postcode
          }
        }
      );

      // Update model
      this.newInvoice.contactId = response.id;

      // Fetch properties and pre-populate the property details from the contact
      this.apiService.getPropertyListByContact(response.id).subscribe(response => {

        // If there are no properties, then we should ensure that the form is reset for properties
        this.ionicForm.patchValue(
        {
          propertyId: '',
          property: {}
        });

        // Create a properties array for the picker with ID and address 1
        this.properties = response.map(function(p) {
          return {
            text: p.address1,
            value: p.id
          }
        });

      })
    });
  }

  dismiss() {  
    this.modalCtrl.dismiss();
  }

  async chooseCustomer() {
    const modal = await this.modalCtrl.create({  
      component: ContactsSelectorComponent,
      canDismiss: true,
      presentingElement: await this.modalCtrl.getTop(), // Get the top-most ion-modal
      componentProps: {  },
    });
   
    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {

      // Pre-populate form values
      this.ionicForm.patchValue(
        {
          contactId: data.id,
          customer: {
            title: data.title,
            first_name: data.first_name,
            last_name: data.last_name,
            mainName: data.mainName,
            email: data.email,
            phone1: data.phone1,
            phone2: data.phone2,
            address1: data.address1,
            address2: data.address2,
            city: data.city,
            postcode: data.postcode
          }
        }
      );

      // Update model
      this.newInvoice.contactId = data.id;

      // Fetch properties and pre-populate the property details from the contact
      this.apiService.getPropertyListByContact(data.id).subscribe(response => {

        // If there are no properties, then we should ensure that the form is reset for properties
        this.ionicForm.patchValue(
        {
          propertyId: '',
          property: {}
        });

        // Create a properties array for the picker with ID and address 1
        this.properties = response.map(function(p) {
          return {
            text: p.address1,
            value: p.id
          }
        });

      })
    }
  }

  async openPropertyPicker() {
    const picker = await this.pickerCtrl.create({
      columns: [
        {
          name: 'properties',
          options: this.properties
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Confirm',
          handler: (value) => {

            // Patch the form with the property ID
            this.ionicForm.patchValue(
              {
                propertyId: value.properties.value,
                property: {
                  name: value.properties.text
                }
              }
            );

            // Update model
            this.newInvoice.propertyId = value.properties.value;

          },
        },
      ],
    });

    await picker.present();
  }

  async openPropertyChooser() {
    const modal = await this.modalCtrl.create({  
      component: PropertyChooserComponent,
      canDismiss: true,
      presentingElement: await this.modalCtrl.getTop(), // Get the top-most ion-modal
      componentProps: { contactId: this.newInvoice.contactId },
    });
   
    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      // Update this model
      this.newInvoice.propertyId = data.id;

      // Patch the form with the property ID
      this.ionicForm.patchValue(
        {
          propertyId: data.id,
          property: {
            name: data.address1
          }
        }
      );

    }
  }

  async chooseBusiness() {
    const modal = await this.modalCtrl.create({  
      component: BusinessSelectorComponent,
      canDismiss: true,
      presentingElement: await this.modalCtrl.getTop(), // Get the top-most ion-modal
      componentProps: {  },
    });
   
    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {

      this.ionicForm.patchValue(
        {
          businessId: data.id,
          business: {
            name: data.name,
            taxName: data.taxName,
          }
        }
      );

      // Set Business to get invoice number preview
      this.chosenBusiness = data;

      // Update model
      this.newInvoice.businessId = data.id;
    }
  }

  // async addWorkItemButton() {
  //   // Provide Currency to WorkItemChooserComponent
  //   const modal = await this.modalCtrl.create({  
  //     component: WorkItemChooserComponent,
  //     canDismiss: true,
  //     presentingElement: await this.modalCtrl.getTop(), // Get the top-most ion-modal
  //     componentProps: { 
  //       currencyCode: this.ionicForm.controls.currency.value,
  //     }
  //   });
  //   modal.onDidDismiss()
  //     .then((data) => {

  //       // This should be an array of Work Items
  //       if (data.data && data.data.length > 0) {

  //         // Map to Work Item model
  //         var newWorkItems = data.data.map(data => new WorkItem().deserialize(data));
          
  //         // Add workItems to array
  //         this.WorkItems.push(...newWorkItems);

  //         // Add WorkItems to Invoice Model
  //         this.newInvoice.WorkItems.push(...newWorkItems);
          
  //         // Check console
  //         console.log(this.WorkItems);
  //       }

  //       // Work Items ready to save when saving the Invoice

  //   });
  //   return await modal.present();
  // }

  // async editWorkItem(workitemIndex) {
  //   const modal = await this.modalCtrl.create({  
  //     component: WorkItemEditComponent,
  //     canDismiss: true,
  //     presentingElement: await this.modalCtrl.getTop(), // Get the top-most ion-modal
  //     componentProps: { 
  //       workItemToUpdate: this.newInvoice.WorkItems[workitemIndex],
  //       currencyCode: this.ionicForm.controls.currency.value,
  //     }
  //   });
  //   modal.onDidDismiss()
  //     .then((data) => {

  //       var updatedWorkItem = data.data;

  //       // This should be a Work Item Model
  //       if (updatedWorkItem) {

  //         console.log(updatedWorkItem);

  //         // Update our Invoice Work Items with this updated Work Item
  //         this.newInvoice.updateWorkItemByIndex(workitemIndex, updatedWorkItem);
          
  //         // Check console
  //         console.log(this.newInvoice.WorkItems);
  //       }

  //   });
  //   return await modal.present();
  // }

  private prepareSave(): Invoice {
    //return new Invoice().deserialize(this.ionicForm.value);

    // Add invoice Date
    this.newInvoice.invoice_date = this.ionicForm.controls.invoice_date.value

    return this.newInvoice;
  }

  async submitForm() {
    this.isSubmitted = true;

    if (!this.ionicForm.valid || this.loadingFromAI) {
      console.log('Please provide all the required values for an invoice.')
      return false;
    } else {

      // Prep the Invoice data
      const newInvoice = this.prepareSave(); // `newInvoice` is now an instance of "Invoice"

      console.log(newInvoice.WorkItems);

      this.WorkItems = newInvoice.WorkItems.slice(0);

      console.log(this.WorkItems);

      // TEMP: REMOVE FROM MODEL AS JSON SERVER SAVES IT ALL
      //delete newInvoice.WorkItems;

      // API Call
      this.apiService.createInvoice(newInvoice).subscribe((response) => {
        // Invoice saved
        console.log(response);

        // Update all Work Items with Invoice ID and Create Work Items
        const observables = this.WorkItems.map((item) => {
          // Set the invoiceId property
          item.invoiceId = response.id;

          // Send to API and return the observable
          return this.apiService.createWorkItem(item);
        });

        forkJoin(observables).subscribe((responses) => {
          // This code will run after all the API calls are completed
          console.log('All API calls completed:', responses);

          // We're finished - check if we have a job ID.
          if (!this.jobId) 
            this.router.navigateByUrl('/t/invoices/view/'+response.id);

        });

        // If no observables (no Work Items to save) then lets ensure we still route to the new invoice
        if (observables.length < 1) {
          if (!this.jobId) 
            this.router.navigateByUrl('/t/invoices/view/'+response.id);
        }

      });

      // Close the modal
      this.modalCtrl.dismiss(this.ionicForm.value); // TODO: Return data, although we should refresh previous view / form
    }
  }

  get errorControl() {
    return this.ionicForm.controls;
  }

  get customerDisplay() {
    if (this.ionicForm.get('customer').value.mainName) {
      return this.ionicForm.get('customer').value.mainName+' - '+this.ionicForm.get('customer').value.email;
    }
    else {
      return 'Choose a customer';
    }
  }

  get businessDisplay() {
    if (this.ionicForm.get('business').value.name) {
      return this.ionicForm.get('business').value.name;
    }
    else {
      return 'Choose a Business';
    }
  }

  get propertyDisplay() {
    if (this.ionicForm.get('property').value.name) {
      return this.ionicForm.get('property').value.name;
    }
    else {
      return 'Choose a Visit Address (optional)';
    }
  }

  // Generate WorkItems using the ai.service.ts
  // async generateWorkItems() {
    
  //   // Generate button is a button that launches an alert for user input to describe the job. We will then send this to our API to generate some WorkItems using OpenAI
  //   this.loadingFromAI = true;

  //   // We can only do this if we have the business ID chosen
  //   if (!this.newInvoice.businessId) {
  //     const alert = await this.alertController.create({
  //       header: 'Please choose a business',
  //       message: 'You need to choose a business before you can generate Work Items',
  //       buttons: ['OK']
  //     });
  //     await alert.present();
  //     this.loadingFromAI = false;
  //     return;
  //   }

  //   try {
  //     const newWorkItems = await this.aiService.jobDescriptionPrompt(this.newInvoice.businessId);
  //     this.loadingFromAI = false;

  //     // Add workItems to array
  //     this.WorkItems.push(...newWorkItems);

  //     // Add WorkItems to Invoice Model
  //     this.newInvoice.WorkItems.push(...newWorkItems);

  //     console.log(newWorkItems);

  //   } catch (error) {
  //     this.loadingFromAI = false;
  //     console.log(error);
  //   }
  // }

  // // removeWorkItem with index of workitem to remove from the WorkItems array newInvoice.WorkItems
  // removeWorkItem(workItemIndex) {
  //   this.WorkItems.splice(workItemIndex, 1);
  //   this.newInvoice.WorkItems.splice(workItemIndex, 1);
  // }

}
